import { CAST_AI } from '@cast/constants';
import { Typography, tokens } from '@cast/design-system';

export const ComplianceStandard = () => (
  <Typography
    variant="P14M"
    component="div"
    color={tokens.theme.fg.structural.secondary}
  >
    Compliance standard:{' '}
    <Typography
      variant="L14B"
      component="span"
      color={tokens.theme.fg.structural.primary}
    >
      {CAST_AI}
    </Typography>
  </Typography>
);
